import React, { useState, useEffect } from 'react';
import { WifiOff } from 'lucide-react';

const OfflineIndicator: React.FC = () => {
  const [isOffline, setIsOffline] = useState(false);

  useEffect(() => {
    // Verificar o estado inicial
    setIsOffline(!navigator.onLine);

    // Adicionar listeners para mudanças de estado
    const handleOffline = () => setIsOffline(true);
    const handleOnline = () => setIsOffline(false);

    window.addEventListener('offline', handleOffline);
    window.addEventListener('online', handleOnline);

    // Cleanup
    return () => {
      window.removeEventListener('offline', handleOffline);
      window.removeEventListener('online', handleOnline);
    };
  }, []);

  if (!isOffline) return null;

  return (
    <div className="fixed bottom-4 right-4 bg-yellow-600 text-white px-4 py-2 rounded-full shadow-lg flex items-center z-50">
      <WifiOff className="h-5 w-5 mr-2" />
      <span>Você está offline</span>
    </div>
  );
};

export default OfflineIndicator; 